import { Component, EventEmitter, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'sbnb-connect-booking-disclaimer',
  templateUrl: './connect-booking-disclaimer.component.html',
  styleUrls: ['./connect-booking-disclaimer.component.scss'],
})
export class ConnectBookingDisclaimerComponent implements OnInit {
  multipleRooms: boolean | null = null;
  iCalsImported: boolean | null = null;

  disclaimerPage = 2;
  pricingType: string;

  @Output() stepComplete: EventEmitter<boolean> = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit(): void {}

  progress() {
    if (this.disclaimerPage === 1 && this.pricingType === 'standard') {
      this.disclaimerPage = 2;
      return;
    }

    if (this.disclaimerPage === 1 && this.pricingType !== 'standard') {
      this.router.navigate(['/accounts/new/booking/requirements-fail'], {
        queryParams: {
          failed: 'pricingType',
        },
      });
      return;
    }

    if (this.multipleRooms === true && this.iCalsImported !== null) {
      this.router.navigate(['/accounts/new/booking/requirements-fail'], {
        queryParams: {
          failed: 'multipleRooms',
        },
      });
      return;
    }

    if (this.iCalsImported === true && this.multipleRooms !== null) {
      this.router.navigate(['/accounts/new/booking/requirements-fail'], {
        queryParams: {
          failed: 'iCalsImported',
        },
      });
      return;
    }

    if (this.multipleRooms === false && this.iCalsImported === false) {
      this.progressToNextScreen();
    }
  }

  progressToNextScreen() {
    this.router.navigate(['/accounts/new/booking/booking-widget']);
  }
}

@Pipe({
  standalone: false,
  name: 'bookingConnectionDocumentationPipe',
})
export class BookingConnectionDocumentationPipe implements PipeTransform {
  constructor() {}

  public transform(disclaimerPage): string {
    switch (disclaimerPage) {
      case 1:
        return '/support-documentation/article/4947106-do-you-support-multi-inventory-properties-and-hotels-on-booking-com';
      case 2:
        return '/support-documentation/article/5388884-what-booking-com-rate-plans-are-supported';
      case 3:
        return '/support-documentation/article/4954763-why-can-t-i-access-guest-details-for-past-reservations-on-booking-com';
      default:
        return '';
    }
  }
}
